import "./App.css";
import { Route, Routes } from "react-router-dom";
import Home from "./Pages/Home/Home";
import AllProducts from "./Pages/AllProducts/AllProducts";
import ProductDetails from "./Pages/ProductDetails/ProductDetails";
import Contact from "./Pages/Contact/Contact";
import Login from "./Pages/Login/Login";
import Profile from "./Pages/Profile/Profile";
import Error from "./Pages/Error/Error";
import CheckOut from "./Pages/CheckOut/CheckOut";
import About from "./Pages/About/About";
import TrackOrder from "./Pages/TrackOrder/TrackOrder";
import Category from "./Pages/Category/Category";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<AllProducts />} />
        <Route path="products/:productId" element={<ProductDetails />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/category" element={<Category />} />
        <Route path="/checkout" element={<CheckOut />} />
        <Route path="/about" element={<About />} />
        <Route path="/track" element={<TrackOrder />} />
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </div>
  );
}

export default App;
